<template>
  <div >
    <h5>Config Success Rates</h5>
    <h6 class="subtitle">Average win percentage of prediction config types by tag version. Click on a tag version or a prediction config to see detail. Click on a bold underlined number to see a detailed report.</h6>
    <h6 class="subtitle">Underlined = is currently live (i.e. would be used for evaluations) | Green = Is currently used for predictions</h6>

    <b-spinner v-if="!dataLoaded" variant="success" label="Spinning"></b-spinner>
    <b-alert :show="dataLoaded && error" variant="danger">{{errorText}}</b-alert>
    <div v-if="dataLoaded && !showTagVersionTable && !error" class="btn-group btn-group-sm" role="group">
      <button type="button" class="btn btn-secondary" @click="loadPage()">All</button>
      <button type="button" class="btn btn-secondary" @click="loadPage('flat')">Flat</button>
      <button type="button" class="btn btn-secondary" @click="loadPage('jumps')">Jumps</button>
    </div>
    <table class="table  table-responsive" v-if="dataLoaded && !showTagVersionTable && !error" style="max-height: 500px">
      <thead >
        <tr>
          <th scope="col">Prediction Config</th>
          <th v-for="tagVersion in successByPredictionConfig.tagVersions" class="clickable" v-on:click="showSuccessByTagVersion(tagVersion)" scope="col">{{tagVersion}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="predictionConfig in successByPredictionConfig.configList">
          <td :class="'clickable ' + (predictionConfig.isLive? 'is-live' : '') + (predictionConfig.isUsedForPredictions? ' is-used-for-predictions': '')" v-on:click="goToPredictionConfig(predictionConfig.name)">{{predictionConfig.name}}</td>
          <td class="green" v-for="tagVersion in successByPredictionConfig.tagVersions" :id="predictionConfig.name + tagVersion" :style="'opacity:' + getOpacity(tagVersion, predictionConfig)" >
            {{averageWinPercentage(predictionConfig.tagVersions[tagVersion])}}
            <b-tooltip :target="predictionConfig.name + tagVersion" >
              {{'rpr: ' + averageReturn(predictionConfig.tagVersions[tagVersion])}}
            </b-tooltip>
          </td>
        </tr>
      </tbody>
    </table>
    <b-row v-if="showTagVersionTable">
      <b-col sm="1">
        <i v-on:click="showTagVersionTable = false" class="material-icons md-24 clickable">navigate_before</i>
      </b-col>
      <b-col sm="11">
        <EvaluationByTagVersionTable :tagVersion="activeTagVersion" :type='typeFilter'/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SuccessByPredictionConfigList from '../models/SuccessByPredictionConfigList'
import SuccessRelativePercentages from '../models/SuccessRelativePercentages'
import * as PredictionConfigList from '../models/PredictionConfigList'
import * as PredictionConfig from '../models/PredictionConfig'
import EvaluationByTagVersionTable from './EvaluationByTagVersionTable'
import ReportsClient from '../clients/ReportsClient'
export default {
  name: 'EvaluationsTable',
  props: {
    evaluations: Array,
    evaluationName: String,

  },
  components: {
    EvaluationByTagVersionTable
  },
  data () {
    return {
      title: 'EvaluationsTable',
      successByPredictionConfig: {},
      dataLoaded: false,
      showTagVersionTable: false,
      activeTagVersion: undefined,
      successRelativePercentages: undefined,
      error: false,
      errorText: undefined,
      typeFilter: undefined
    }
  },
  methods: {
    averageWinPercentage: function(tagVersionObj) {
      if (tagVersionObj) {
        return (average(tagVersionObj.winPercentage) * 100).toFixed(2)
      }else {
        return 0
      }
    },
    averageReturn: function(tagVersionObj) {
      if (tagVersionObj) {
        return (average(tagVersionObj.rpr)).toFixed(4)
      }else {
        return 0
      }
    },
    goToPredictionConfig: function(name) {
      this.$router.push({name:'PredictionConfig', params: {configId: name}})
    },
    showSuccessByTagVersion: function (tagVersion) {
      this.showTagVersionTable = true
      this.activeTagVersion = tagVersion
    },
    getOpacity: function(tagVersion, predictionConfig) {
      if (this.averageWinPercentage(predictionConfig.tagVersions[tagVersion]) === 0) return 0
      return (this.successRelativePercentages.map[tagVersion][average(predictionConfig.tagVersions[tagVersion].winPercentage)] * 0.7 + 0.3)
    },
    loadPage: function (type) {
      this.typeFilter = type
      var query
      if (type) {
        query = [{type:type}]
      }
      this.dataLoaded = false
      this.error = false
      this.successByPredictionConfig = new SuccessByPredictionConfigList()
      this.successByPredictionConfig.load(query)
      .then(response => {
        this.successRelativePercentages = new SuccessRelativePercentages(response)
        return this.successByPredictionConfig.addLiveStatus()
      })
      .then(() => {
        this.dataLoaded = true
      })
      .catch(err => {
        this.dataLoaded = true
        this.error = true
        console.error(err)
        this.errorText = "Failed to load evaluations"
      })
    }
  },
  watch: {
    $route(to, from) {
      console.log(to)
      if (to.name === "Dashboard") this.loadPage()
    }
  },
  mounted () {
    this.loadPage()
  }
}

function average(array) {
  if (array) {
    const sum = array.reduce((a, b) => a + b, 0);
    return (sum / array.length) || 0;
  }else {
    return 0
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#nameCell {
  font-size: 10pt
}

.green {
  background-color: green
}

.is-live {
  text-decoration: underline;
  font-weight: bold;
}

.is-used-for-predictions {
  color: green
}
</style>
